import { html, css } from "./../../utils/template-literal-tags";

class MainMenuBar extends HTMLElement {
  #buttons = null;
  #sections = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = html`
      <div id="main-menu">
        <nav id="main-nav">
          <div class="nav-button selected" data-id="home">
            <span class="icon">
              <iconify-icon icon="cil:applications"></iconify-icon>
            </span>
            <span class="label">Dashboard</span>
          </div>
          <div class="nav-button" data-id="habits">
            <span class="icon">
              <iconify-icon icon="cil:apple"></iconify-icon>
            </span>
            <span class="label">Habits</span>
          </div>
          <div class="nav-button" data-id="projects">
            <span class="icon">
              <iconify-icon icon="cil:folder-open"></iconify-icon>
            </span>
            <span class="label">Projects</span>
          </div>
          <div class="nav-button" data-id="books">
            <span class="icon">
              <iconify-icon icon="cil:book"></iconify-icon>
            </span>
            <span class="label">Books</span>
          </div>
        </nav>
      </div>
    `;

    this.#buttons = this.querySelectorAll("div.nav-button");
    this.#sections = document.querySelectorAll("section.main");
    this.#setupInitialSection();
    this.#setupNavButtons();
  }

  triggerSection(id = "home") {
    this.#buttons.forEach((button) => {
      button.classList.toggle("selected", button.dataset.id === id);
    });

    this.#sections.forEach((section) => {
      section.classList.toggle("selected", id === section.id);
    });

    window.history.pushState({}, "", `/${id}`);
  }

  #setupInitialSection() {
    const pathname = window.location.pathname.replace("/", "") || "home";
    this.triggerSection(pathname);
  }

  #setupNavButtons() {
    const eventType = "ontouchstart" in window ? "touchstart" : "click";
    const passive = eventType === "touchstart" ? { passive: false } : {};

    this.#buttons.forEach((button) => {
      button.addEventListener(
        eventType,
        (event) => {
          if (eventType === "touchstart") {
            event.preventDefault();
          }

          this.triggerSection(button.dataset.id);
        },
        passive,
      );
    });
  }
}

customElements.define("main-menu-bar", MainMenuBar);
